<script type="text/babel">
  export default {
    name: 'GoogleMapChildren',
    data() {
      return {
        item: null,
      }
    },
    mounted() {
      if (this.$parent.ready) {
        this.init()
      } else {
        this.$parent.$on('map-ready', () => {
          this.init()
        })
      }
    },
    beforeDestroy() {
      this.item.setMap(null)
    },
    methods: {
      getMap: function () {
        return this.$parent.getMap()
      },
      addButton: function (title, callback) {
        var buttonDiv = document.createElement('div')
        //buttonDiv.index = 1;

        var borderDiv = document.createElement('div')
        borderDiv.style.backgroundColor = '#fff'
        borderDiv.style.border = '2px solid #fff'
        borderDiv.style.borderRadius = '3px'
        borderDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
        borderDiv.style.cursor = 'pointer'
        borderDiv.style.margin = '5px'
        borderDiv.style.textAlign = 'center'

        buttonDiv.appendChild(borderDiv)

        var contentDiv = document.createElement('div')
        contentDiv.style.color = 'rgb(25,25,25)'
        contentDiv.style.fontFamily = 'Roboto,Arial,sans-serif'
        contentDiv.style.lineHeight = '20px'
        contentDiv.style.paddingLeft = '5px'
        contentDiv.style.paddingRight = '5px'
        contentDiv.innerHTML = title
        borderDiv.appendChild(contentDiv)

        borderDiv.addEventListener('click', callback)

        this.getMap().controls[google.maps.ControlPosition.TOP_CENTER].push(buttonDiv)
      }
    }
  }
</script>

